import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { Alert, AlertDescription } from "@/components/ui/alert";
import PageHeader from "../PageHeader";
import SnippetForm from "./SnippetForm";
import { snippetApi } from "../../services/api";

function EditSnippet() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [snippet, setSnippet] = useState(null);
  const [loading, setLoading] = useState(true);
  const [loadError, setLoadError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setLoadError(null);
    snippetApi
      .get(slug)
      .then((response) => {
        if (!cancelled) {
          setSnippet(response.data);
          setLoading(false);
        }
      })
      .catch((err) => {
        if (!cancelled) {
          setLoadError(err?.response?.status === 404 ? "notfound" : "load");
          setLoading(false);
        }
      });
    return () => {
      cancelled = true;
    };
  }, [slug]);

  const handleSubmit = async (data) => {
    await snippetApi.update(slug, data);
    navigate(`/snippets/${slug}`);
  };

  const handleCancel = () => navigate(`/snippets/${slug}`);

  if (loading) {
    return (
      <div className="page-container mt-6 py-12 pt-4 text-center" role="status">
        <Loader2 className="inline size-6 animate-spin text-muted-foreground" />
        <span className="sr-only">Loading snippet...</span>
      </div>
    );
  }

  if (loadError === "notfound") {
    return (
      <div className="page-container mt-6 pt-4">
        <Alert>
          <AlertDescription>Snippet not found.</AlertDescription>
        </Alert>
      </div>
    );
  }

  if (loadError) {
    return (
      <div className="page-container mt-6 pt-4">
        <Alert variant="destructive">
          <AlertDescription>Failed to load snippet.</AlertDescription>
        </Alert>
      </div>
    );
  }

  return (
    <div className="page-container mt-6 pt-4" style={{ maxWidth: 880 }}>
      <PageHeader
        title="Edit snippet"
        subtitle={snippet.title || snippet.slug}
      />
      <SnippetForm
        initialValue={snippet}
        submitLabel="Save changes"
        onSubmit={handleSubmit}
        onCancel={handleCancel}
      />
    </div>
  );
}

export default EditSnippet;
